module.exports = __webpack_public_path__ + "static/media/landingImage2.95aa8044.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landingImage2.png
// module id = 554
// module chunks = 0